import React from 'react';
import { useLang } from '../i18n/LangContext';
import { CONTACT } from '../data/content';
import { Phone, Mail, MessageCircle } from 'lucide-react';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1f1d1a] text-[#EFEBDF]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="font-serif text-3xl md:text-4xl mb-4">Obach Rural</p>
          <p className="text-white/60 text-sm leading-relaxed">
            {CONTACT.address}
          </p>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-white/40 mb-4">
            {t.footer.book}
          </p>
          <p className="text-white/75 text-sm leading-relaxed max-w-xs">
            {t.footer.bookSub}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <a href={`tel:${CONTACT.phoneRaw}`} className="inline-flex items-center gap-3 text-white/85 hover:text-white transition-colors">
            <Phone size={16} className="opacity-80" /> {CONTACT.phone}
          </a>
          <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 text-white/85 hover:text-white transition-colors">
            <MessageCircle size={16} className="opacity-80" /> WhatsApp
          </a>
          <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-3 text-white/85 hover:text-white transition-colors break-all">
            <Mail size={16} className="opacity-80" /> {CONTACT.email}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/40">
          <span>© {year} Obach Rural. {t.footer.rights}</span>
          <span>obachrural.com</span>
        </div>
      </div>
    </footer>
  );
}
